import { AppUser } from '@eventr/common'
import { query } from '../../../state/headerState/headerSignals'
import { IOptionsWithTypes } from '../../../state/interfaces'

export const checkIfUserSelected = (
    userId: number,
    memberList: IOptionsWithTypes[]
): boolean => {
    if (!memberList) return false
    return memberList.some((itineraryUser) => {
        if (itineraryUser.type === 'User') {
            if (itineraryUser.option === userId) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    })
}
export const checkIfTagSelected = (
    tagName: string,
    memberList: IOptionsWithTypes[],
    tagTypes: string[]
): boolean => {
    if (!memberList) return false
    const orgUser = memberList?.find((itineraryUser) => {
        if (tagTypes.includes(itineraryUser.type)) {
            if (itineraryUser.option === tagName) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    })
    if (orgUser) {
        return true
    } else {
        return false
    }
}

export const checkIfUserTagSelected = (
    userId: number,
    memberList: IOptionsWithTypes[],
    allOrgUsers: AppUser[]
): boolean => {
    if (!memberList) return false
    const orgUser = allOrgUsers?.find((itineraryUser) => {
        return itineraryUser.id === userId
    })

    const departmetSelected = orgUser.departmentTags.some((tag) => {
        return checkIfTagSelected(tag, memberList, ['Department'])
    })

    const groupSelected = orgUser.groupTags.some((tag) => {
        return checkIfTagSelected(tag, memberList, ['Group'])
    })

    if (departmetSelected || groupSelected) {
        return true
    } else {
        return false
    }
}
export const filterBySearch = (userList: AppUser[]) => {
    const filteredList = userList.filter((user) => {
        return (
            user.firstName.toLowerCase().includes(query.value.toLowerCase()) ||
            user.lastName.toLowerCase().includes(query.value.toLowerCase()) ||
            [user.firstName, user.lastName]
                .join(' ')
                .toLowerCase()
                .includes(query.value.toLowerCase()) ||
            user.email.toLowerCase().includes(query.value.toLowerCase())
        )
    })
    return filteredList
}
